import {
	SET_VIDEO_LIBRARY_DATA,
	TOGGLE_VIDEO_LIBRARY_SLIDER,
	UPDATE_VIDEO_IN_LIBRARY,
	DELETE_VIDEO_LIBRARY,
	UPLOAD_YOUTUBE_VIDEO,
	LINK_VIDEO_TO_PRODUCT,
	UNLINK_VIDEO,
	LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT,
	UNLINK_VIDEO_TOP_RODUCT_FROM_ADD_EDIT,
	UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT,
	ADD_VIDEO_TO_LIBRARY,
	REMOVE_VIDEO_FROM_LIBRARY
} from '../actions/types'

const initialState = {
	videos: {

	},
	showLibrarySlider: false,
	ignoreSave: false
}

export default (state = initialState, action) => {
	const payload = action.payload;

	switch (action.type) {
		case SET_VIDEO_LIBRARY_DATA: {
			const videos = state.videos;
			payload.videosData.map((cur, i) => {
				const video = {
					...cur
				};
				delete video.videoId
				videos[cur.videoId] = video
			})

			return {
				...state,
				videos
			}
		}
		case TOGGLE_VIDEO_LIBRARY_SLIDER: {
			return {
				...state,
				showLibrarySlider: payload.flag,
				productUnderEdit: payload.productId,
				ignoreSave: payload.ignoreSave,
				onFileUpload: payload.onFileUpload,
				isAddEditProduct: payload.isAddEditProduct,
				isEnrchProductPage: payload.isEnrchProductPage,
				fromViewImageSlider: payload.fromViewImageSlider,
				isAddEditProductOmni: payload.isAddEditProductOmni
			}
		}
		case UPDATE_VIDEO_IN_LIBRARY: {
			const newState = {
				...state
			}
			const videos = newState.videos;
			let curVideo = {...videos[payload.imgIndex]} || {};
			let newVariantIdsToLink;
			if(payload.variantIdsToLink){
				newVariantIdsToLink = [...payload.variantIdsToLink];
				delete payload.variantIdsToLink;
			}
			curVideo = {
				...curVideo,
				...payload
			}
			if(newVariantIdsToLink && newVariantIdsToLink.length){
				curVideo.variantIdsToLink = curVideo.variantIdsToLink || [];
				curVideo.variantIdsToLink.push(...newVariantIdsToLink);
			} else if(payload.allVideosLinked){
				delete curVideo.allVideosLinked
				delete curVideo.variantIdsToLink
			}
			let oldId = curVideo.oldId || curVideo.imgIndex;
			let videoId = payload.imgIndex;
			if(payload.updateVideoId){
				delete videos[videoId]
				videoId = payload.newVideoId;
			}
			videos[videoId] = {...curVideo,oldId};
			newState.videos = videos;
			return newState
		}
		case UNLINK_VIDEO: {
			const newState = {
				...state
			}
			const videos = newState.videos;
			let curVideo = {...videos[payload.videoId]} || {};
			curVideo.variantIdsToLink = curVideo.variantIdsToLink || [];
			if(!curVideo.uploaded){
				curVideo.variantIdsToLink = curVideo.variantIdsToLink.filter((cur) => cur !== payload.productId);
			}
			videos[payload.videoId] = curVideo;
			newState.videos = videos;
			return newState
		}
		case LINK_VIDEO_TO_PRODUCT: {
			const newState = {
				...state
			}
			const videos = newState.videos;
			let curVideo = {...videos[payload.videoId]} || {};
			if(!curVideo.uploaded){
				curVideo.variantIdsToLink = curVideo.variantIdsToLink || [];
				curVideo.variantIdsToLink.push(payload.variantId);
			}
			videos[payload.videoId] = curVideo;
			newState.videos = videos;
			return newState
		}
		case DELETE_VIDEO_LIBRARY: {
			const newState = {
				...state
			}
			delete newState.videos[payload.videoId]
			return newState;
		}
		case UPLOAD_YOUTUBE_VIDEO: {
			const newState = {
				...state
			};
			newState.videos[payload.videoId] = {
				videoName: payload.videoName,
				status: "UNDER_REVIEW",
				source: "YOUTUBE",
				imgURL: payload.imgURL,
				thumbnailURL: payload.thumbnailURL,
				uploaded: true,
				isVideo: true,
				actualPath: payload.link
			}
		}
		case LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT: {
			const newState = {
				...state
			}
			const videos = newState.videos;
			let curVideo = {...videos[payload.videoId]} || {};
			if(!curVideo.uploaded){
				curVideo.variantIdsToLink = curVideo.variantIdsToLink || [];
				curVideo.variantIdsToLink.push(payload.variantId);
			}
			videos[payload.videoId] = curVideo;
			newState.videos = videos;
			return newState
		}
		case UNLINK_VIDEO_TOP_RODUCT_FROM_ADD_EDIT:{
			const newState = {
				...state
			}
			const videos = newState.videos;
			let curVideo = {...videos[payload.videoId]} || {};
			curVideo.variantIdsToLink = curVideo.variantIdsToLink || [];
			if(!curVideo.uploaded){
				curVideo.variantIdsToLink = curVideo.variantIdsToLink.filter((cur) => cur !== payload.productId);
			}
			videos[payload.videoId] = curVideo;
			newState.videos = videos;
			return newState
		}
		case UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT:{
			const newState = {
				...state
			};
			newState.videos[payload.videoId] = {
				videoName: payload.videoName,
				status: "UNDER_REVIEW",
				source: "YOUTUBE",
				imgURL: payload.imgURL,
				thumbnailURL: payload.thumbnailURL,
				uploaded: true,
				isVideo: true,
				actualPath: payload.link
			}
			return newState;
		}
		case ADD_VIDEO_TO_LIBRARY: {
			const videos = state.videos;
			videos[payload.videoId] = payload.videodata;
			return {
				...state,
				videos
			}
		}
		case REMOVE_VIDEO_FROM_LIBRARY: {
			const videos = state.videos;
			delete videos[payload.videoId];
			return {
				...state,
				videos
			}
		}
		default:
			return state;
	}
}